<template>
  <h1>Announcements</h1>
  <div
    v-for="announcement in $store.getters.orderedAnnouncements"
    :key="announcement"
    class="mc-panel announcement"
  >
    <h3>{{ announcement.title }}</h3>
    <p class="description" v-html="announcement.description" /> <!-- eslint-disable-line vue/no-v-html -->
    <p class="time">
      {{ dateToISO(announcement.time) }}
    </p>
  </div>
  <p v-if="!$store.getters.orderedAnnouncements.length" class="mc-panel empty">
    No announcements yet
  </p>
</template>

<script>
// TODO i was lazy making this announcement view, maybe make something more interesting like the notifications popup from watevrctf
import { dateToISO } from '@/utilityFunctions.js'

export default {
    mounted () {
        this.$store.commit('readAnnouncements')
        Notification.requestPermission()
    },
    methods: {
        dateToISO,
    },
}
</script>

<style lang="scss" scoped>
.announcement {
    margin-bottom: 1.5rem;
}

h3 {
    margin-bottom: 0.5rem;
    line-height: 1.25;
}
p {
    margin: 0;
}

.time {
    color: $ssm-muted;
}

.description {
    margin-bottom: 0.5rem;
    white-space: pre-wrap;
}

.empty {
    display: inline-block;
}
</style>
